import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Observable, from } from 'rxjs';
import { BackendErrorType } from '../services/errors/backend.errors';
import { LandingpageConfigurationStateService } from '../services/state/landingpage-configuration-state.service';

@Injectable({
  providedIn: 'root',
})
/***
 routes either to OverviewComponent, Error page or AccessToken Component, dependig on the validity of the token passed in the url
 ***/
export class CheckForTokenGuard implements CanActivate {
  private router = inject(Router);
  private logger = inject(NGXLogger);
  private landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);

  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree> | UrlTree {
    if (!route.queryParamMap.has('code')) {
      return this.router.parseUrl('/');
    }
    const token = route.queryParamMap.get('code')!;
    return this.isTokenValid(token);
  }

  isTokenValid(token: string): Observable<UrlTree> {
    return new Observable<UrlTree>((observer) => {
      from(this.landingpageConfigurationStateService.fetchOrganisationForToken(token)).subscribe({
        next: () => {
          this.logger.debug('Request Landingpage Organisation:', {
            requestParam: token,
          });

          observer.next(this.router.parseUrl('/auth'));
        },
        error: (error: Error) => {
          if (error.message === BackendErrorType.ALREADY_SENT) {
            observer.next(this.router.createUrlTree(['already-sent'], { queryParams: { code: token } }));
          } else if (error.message === BackendErrorType.VERIFICATION_ERROR) {
            observer.next(this.router.parseUrl('verification-error'));
          } else {
            observer.next(this.router.parseUrl('/'));
          }
        },
      });
    });
  }
}
